const HYDRATE_ACTION_TYPE = '@eggs/hydrate';

export { HYDRATE_ACTION_TYPE };
